export default "__VITE_ASSET__291cd232__"